let drawer = false;
const initialState = !!drawer;
const drawerCloseReducer = (state = initialState, action = {}) => {
    switch (action.type) {
    case 'SHOW_DRAWER':
        drawer = state;
        return action.payload;


    default:
        return state;
    }
}

export default drawerCloseReducer;
